export default __webpack_public_path__ + "static/media/logo_mobile.6391afeb.svg";